var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "url(#paint0_linear_9684_21695)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8013 10.4578C26.1044 10.0807 26.0552 9.52027 25.6916 9.20602C25.3279 8.89178 24.7874 8.94273 24.4844 9.31982L18.3236 16.9857C17.0861 18.5255 16.2155 19.6054 15.4604 20.3124C14.723 21.003 14.214 21.2224 13.7143 21.2224C13.2146 21.2224 12.7056 21.003 11.9681 20.3124C11.2131 19.6054 10.3425 18.5255 9.10497 16.9857L7.51564 15.0081C7.21258 14.631 6.6721 14.58 6.30843 14.8943C5.94477 15.2085 5.89563 15.7689 6.19869 16.146L7.83214 18.1785C9.0153 19.6508 9.96282 20.8298 10.8192 21.6317C11.7039 22.46 12.6082 23 13.7143 23C14.8204 23 15.7247 22.46 16.6093 21.6317C17.4657 20.8298 18.4133 19.6508 19.5964 18.1786L25.8013 10.4578Z",
    fill: "#F9F9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9684_21695",
    x1: 1.29505e-7,
    y1: -2.88,
    x2: 38.2149,
    y2: 5.07398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#597BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4365E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.9d135de2f4e8de1ecf2465a923ef3e55.svg";
export { ForwardRef as ReactComponent };